import {
  Box,
  Button,
  CircularProgress,
  Fade,
  Grid,
  Skeleton,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CustomTextFiled from "components/CustomTextField";
import { FORM_VALIDATIONS } from "constants/formValidation";
import { CART_DELV_TYPE, YES_NO_TYPES } from "constants/general";
import { Controller, useWatch } from "react-hook-form";
import { useAppSelector } from "store/appHooks";
import AddressContainer from "./AddressContainer";
import ApprovalBtn from "./ApprovalBtn";
import { SubTitle, Title } from "./MuiStyles";
import OldAddressContainer from "./OldAddressContainer";

const ApprovalForm = (props: any) => {
  const { control, userConfigLoading } = props;
  const theme = useTheme();
  const { authReducer, userReducer }: any = useAppSelector((state) => state);
  const isMobileView = useMediaQuery(theme.breakpoints.down("md"));
  const offerDelvPickup = useWatch({
    control,
    name: "offer_delv_pickup",
  });
  const offerOperatorSerice = useWatch({
    control,
    name: "offer_operator_service",
  });
  return (
    <Grid container spacing={2.5} px={1} py={0.5} pt={0}>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Typography
          sx={{
            fontFamily: "Inter",
            fontWeight: 600,
            fontSize: isMobileView ? "16px" : "24px",
            lineHeight: "35px",
          }}
        >
          Set your approval policy
        </Typography>
        <SubTitle>
          Minimize the wait time. Set your terms and simplify your approval
          policy, allowing renters to book your equipment within no time!
        </SubTitle>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Title>How would you like to approve your Rental Requests?</Title>
        <SubTitle>
          Offering Delivery and Pickup Services will maximize your Rental
          prospects and Earnings.
        </SubTitle>
        <Controller
          control={control}
          name={"offer_delv_pickup"}
          rules={{ ...FORM_VALIDATIONS.REQUIRED }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Stack
              direction="row"
              // justifyContent="center"
              alignItems="center"
              spacing={2}
              my={1.5}
            >
              <ApprovalBtn
                label="Pickup"
                icon={require("assets/img/png/Pickup.png")}
                selected={value === CART_DELV_TYPE.PICKUP}
                onBtnClick={() => onChange(CART_DELV_TYPE.PICKUP)}
                userConfigLoading={userConfigLoading}
              />
              <ApprovalBtn
                label="Delivery"
                icon={require("assets/img/png/delivery.png")}
                selected={value === CART_DELV_TYPE.DELIVERY}
                onBtnClick={() => onChange(CART_DELV_TYPE.DELIVERY)}
                userConfigLoading={userConfigLoading}
              />
              {!!error && (
                <Typography color="error" variant="caption">
                  {"Please select delivery type" ?? ""}
                </Typography>
              )}
            </Stack>
          )}
        />

        {Number(offerDelvPickup) === 1 && (
          <Fade in={true} style={{ transitionDuration: "500ms" }}>
            <Grid container spacing={[2, 4]}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Controller
                  control={control}
                  name={"min_delv_pickup_fees"}
                  rules={{
                    ...FORM_VALIDATIONS.REQUIRED,
                    ...FORM_VALIDATIONS.ONLY_NUMBER,
                  }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <CustomTextFiled
                      showEndDropDown={false}
                      inputValue={value}
                      label="Enter delivery amount $"
                      onInputChange={onChange}
                      showError={!!error}
                      errorMessage={error?.message || " "}
                      inputProps={{ type: "number" }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Controller
                  control={control}
                  name={"max_delv_distance"}
                  rules={{
                    ...FORM_VALIDATIONS.REQUIRED,
                    ...FORM_VALIDATIONS.ONLY_NUMBER,
                  }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <CustomTextFiled
                      inputValue={value}
                      label="Enter delivery distance"
                      onInputChange={onChange}
                      showError={!!error}
                      errorMessage={error?.message || " "}
                      dropDownOptions={[
                        { id: "miles", name: "Miles" },
                        // { id: "km", name: "km" },
                      ]}
                      dropDownValue={"miles"}
                      showEndDropDown={true}
                      onDropDownChange={() => {}}
                      inputProps={{ type: "number" }}
                    />
                  )}
                />
              </Grid>
            </Grid>
          </Fade>
        )}
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Title>Do you offer Operator Services?</Title>
        <Controller
          control={control}
          name={"offer_operator_service"}
          rules={{ ...FORM_VALIDATIONS.REQUIRED }}
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <Stack
              direction="row"
              // justifyContent="center"
              alignItems="center"
              spacing={2}
              my={1.5}
            >
              <ApprovalBtn
                label="Yes"
                selected={value === YES_NO_TYPES.YES}
                onBtnClick={() => onChange(YES_NO_TYPES.YES)}
                userConfigLoading={userConfigLoading}
              />
              <ApprovalBtn
                label="No"
                selected={value === YES_NO_TYPES.NO}
                onBtnClick={() => onChange(YES_NO_TYPES.NO)}
                userConfigLoading={userConfigLoading}
              />
              {!!error && (
                <Typography color="error" variant="caption">
                  {"Please select one option" ?? ""}
                </Typography>
              )}
            </Stack>
          )}
        />
        {Number(offerOperatorSerice) === 1 && (
          <Fade in={true} style={{ transitionDuration: "500ms" }}>
            <Grid container spacing={[2, 4]}>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Controller
                  control={control}
                  name={"min_operator_fee"}
                  rules={{
                    ...FORM_VALIDATIONS.REQUIRED,
                    ...FORM_VALIDATIONS.ONLY_NUMBER,
                  }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <CustomTextFiled
                      showEndDropDown={false}
                      inputValue={value}
                      label="Enter min. amount $"
                      onInputChange={onChange}
                      showError={!!error}
                      errorMessage={error?.message || " "}
                      inputProps={{ type: "number" }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
                <Controller
                  control={control}
                  name={"max_operator_fee"}
                  rules={{
                    ...FORM_VALIDATIONS.REQUIRED,
                    ...FORM_VALIDATIONS.ONLY_NUMBER,
                  }}
                  render={({
                    field: { onChange, value },
                    fieldState: { error },
                  }) => (
                    <CustomTextFiled
                      showEndDropDown={false}
                      inputValue={value}
                      label="Enter max. amount $"
                      onInputChange={onChange}
                      showError={!!error}
                      errorMessage={error?.message || " "}
                      inputProps={{ type: "number" }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Typography
                  sx={{
                    fontSize: "14px",
                    lineHeight: "24px",
                    fontWeight: 500,
                    mt: isMobileView ? -1 : -2.5,
                  }}
                >
                  <span style={{ fontWeight: 600, color: "#D21A00" }}>
                    Note:{" "}
                  </span>
                  Operator fees can fluctuate based on the your equipment. These
                  charges are designed to help estimate costs.
                </Typography>
              </Grid>
            </Grid>
          </Fade>
        )}
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Title>Set Security Deposit</Title>
        <SubTitle>
          The minimum deposit for your equipment type is $500.
        </SubTitle>
        <Grid container spacing={[2, 4]}>
          <Grid mt={1.5} item xs={12} sm={12} md={6} lg={6} xl={6}>
            {userConfigLoading ? (
              <Skeleton
                variant="rectangular"
                sx={{ width: "100%", height: "40px" }}
              />
            ) : (
              <Controller
                control={control}
                name={"security_deposit"}
                rules={{
                  ...FORM_VALIDATIONS.REQUIRED,
                  ...FORM_VALIDATIONS.ONLY_NUMBER_FLOAT,
                  ...FORM_VALIDATIONS.minValidation(1),
                }}
                render={({
                  field: { onChange, value },
                  fieldState: { error },
                }) => (
                  <CustomTextFiled
                    showEndDropDown={false}
                    inputValue={value}
                    label="Enter amount $"
                    onInputChange={onChange}
                    showError={!!error}
                    errorMessage={error?.message || " "}
                    inputProps={{ type: "number" }}
                  />
                )}
              />
            )}
          </Grid>
        </Grid>
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <Title>Share the equipment location address</Title>
        <SubTitle sx={{ mb: 1.5 }}>
          Share your exact location to allow renters within a 50 miles radius
          easy access.
        </SubTitle>
        {/* <AddressContainer {...props} /> */}
        <OldAddressContainer {...props} />
      </Grid>

      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <br />
        <br />
        <Box
          pt={2}
          pb={5}
          display="flex"
          justifyContent={isMobileView ? "center" : "end"}
        >
          <Button
            variant="contained"
            size="large"
            type="submit"
            disabled={userReducer.savingUserConfig}
            endIcon={
              userReducer.savingUserConfig ? (
                <CircularProgress size={15} />
              ) : null
            }
            {...(isMobileView && { fullWidth: true })}
          >
            Save
          </Button>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ApprovalForm;
